import React from 'react';
import { useProjectsStore } from '@/stores/projects';
import { useUiStore } from '@/stores/ui';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
export default function ProxyPage() {
    const { activeProjectId, byId: projectsById } = useProjectsStore();
    const activeProject = activeProjectId ? projectsById[activeProjectId] : null;
    const { setHeaderTitle } = useUiStore();
    const navigate = useNavigate();
    React.useEffect(() => {
        setHeaderTitle(activeProject ? `App: ${activeProject.name}` : 'App Proxy');
    }, [setHeaderTitle, activeProject]);
    if (!activeProject?.proxyPort) {
        return (
            <div className="flex items-center justify-center h-full text-center p-4">
                <div className="max-w-md">
                    <h2 className="text-xl font-semibold">Proxy Not Configured</h2>
                    <p className="text-muted-foreground mt-2">
                        The active project does not have a proxy port configured. You can set one in the project settings.
                    </p>
                    <Button className="mt-4" onClick={() => navigate('/pages/settings/')}>
                        Go to Settings
                    </Button>
                </div>
            </div>
        );
    }
    return (
        <div className="h-full w-full bg-white p-1 rounded-md">
            <iframe
                src="/api/proxy/"
                title="Proxied Application"
                className="w-full h-full border rounded-md"
            />
        </div>
    );
}